import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LocationGroup } from 'src/app/BIZ_CRM/biz_crm_classes/location-group';
import { LocationGroupService } from 'src/app/BIZ_CRM/biz_crm_services/location-group.service';
import { SharedDataService } from 'src/app/services/sharedData.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-location-group',
  templateUrl: './update-location-group.component.html',
  styleUrls: ['./update-location-group.component.scss']
})
export class UpdateLocationGroupComponent implements OnInit {

  lg : LocationGroup = new LocationGroup();
  clicked = false;

  @Output() passEntry : EventEmitter<any> = new EventEmitter;
  @Input() fromParent : any;
  loggedInUser: any;
  theme : any;

  constructor(private locationGroupService : LocationGroupService,
    private activeModal : NgbActiveModal,
    private sharedDataService : SharedDataService,
    private toastr : ToastrService) { }

  ngOnInit(): void {

    this.lg = this.fromParent.lg;

    this.loggedInUser = JSON.parse(this.sharedDataService.getLoggedInUserDtls());
    this.theme = this.sharedDataService.getCardOfficeTheme();

  }

  onSubmit(){
    this.locationGroupService.updateLocationGroup(environment.apiUrl + "locationGroup/updateLocationGroup" , this.lg).then(
      data=>{
        this.lg = data;
        this.toastr.success("LocationGroup updated successfully");
        this.passEntry.emit(this.lg);
        this.activeModal.close();
      });
  }

  getColor(){
    this.sharedDataService.setfooterColor(this.loggedInUser.offices[0].theme);
    return this.loggedInUser.offices[0].theme + '!important';
  }

  closeUpdateModal(){
    this.activeModal.close();
  }
}
